import { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Modal, Divider, useToaster, Message, InputGroup, Input } from "rsuite";
import { selector } from "../../../api";
import moment from "moment";
import { appCRUD } from "../../../actions/app";
import SearchIcon from "@rsuite/icons/Search";
import { char } from "../../../utils";

export const StudentAdd = (props) => {
  const { open, setOpen, index, setIndex } = props;
  const user = selector.User();
  const toaster = useToaster();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [isFound, setIsFound] = useState(true);
  const [isStudent, setIsStudent] = useState(false);
  const [isStudentFound, setIsStudentFound] = useState(false);
  const [academicId, setAcademicId] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);
  const [programId, setProgramId] = useState(null);


  useEffect(() => {
    if(data && data?.code === 200){
        setLoading(true);
        setTimeout(() => {
          appCRUD
            .loadAcademicYear(data?.message?.academic?.name)
            .then((resp) => {
              setAcademicId(resp.data[0].id);
            })
            .catch(() => {});
          appCRUD
            .loadSchool(data?.message?.school?.code)
            .then((resp) => {
              setSchoolId(resp.data[0].id);
            })
            .catch(() => {});
          appCRUD
            .loadDepartment(data?.message?.department?.code)
            .then((resp) => {
              setDepartmentId(resp.data[0].id);
            })
            .catch(() => {});
          appCRUD
            .loadProgramme(data?.message?.programme?.code)
            .then((resp) => {
              setProgramId(resp.data[0].id);
            })
            .catch(() => {});
          appCRUD
            .loadStudentReg(data?.message?.student?.registration_number)
            .then((resp) => {
              if (resp.data.length) {
                setIsStudentFound(true);
              }
            })
            .catch(() => {
              setIsStudentFound(false);
            })
            .finally(() => {
              setLoading(false);
            });
        }, 500);
    }
  },[data]);

  useEffect(() => {
    if (data?.code === 200) {
      if (!academicId) {
        const academicData = {
          name: data?.message?.academic?.name,
          is_active: true,
          recorded_by: user.id,
        };
        appCRUD
          .addAcademic(academicData)
          .then((resp) => {
            setAcademicId(resp.data.id);
          })
          .catch((error) => {});
      }
    }
  }, [data, academicId]);

  const handleSearch = () => {
    setLoading(true);
    setTimeout(() => {
        appCRUD.requestStudent({registration_number : search}).then((resp) => {
            setData(resp.data);
            if(resp.data.code !== 200){
                setIsFound(false); 
                setIsStudent(false);
            } else {
                setIsFound(true);
                setIsStudent(true);
            }
        }).catch((error) => {
          toaster.push(
            <Message type="error" showIcon header={"Error"} closable>
              <p className="h6">
                <p className="fw-bold fs-14">Oooh Sorry...!</p>
                <p className="text-dark fs-12">{error}.</p>
              </p>
            </Message>,
            { placement: "topEnd", duration: 7000 }
          );
        }).finally(() => {
            setLoading(false);
        });
    }, 500);
  };

  const handleSubmit = () => {
    setLoading(true);

    setTimeout(() => {
        const schoolData = {
            name : data?.message?.school?.name,
            code : data?.message?.school?.code,
            is_active : true,
            recorded_by : user.id
        }
        if(!schoolId && !departmentId && !programId){
            appCRUD.addSchool(schoolData).then((resp) => {
                const schoolId = resp.data.id;
                const departmentData = {
                  name: data?.message?.department?.name,
                  code: data?.message?.department?.code,
                  school: schoolId,
                  is_active: true,
                  recorded_by: user.id,
                };
                appCRUD
                  .addDepartment(departmentData)
                  .then((resp) => {
                    const departmentId = resp.data.id;
                    const programData = {
                      name: data?.message?.programme?.name,
                      code: data?.message?.programme?.code,
                      department: departmentId,
                      is_active: true,
                      recorded_by: user.id,
                    };
                    appCRUD
                      .addProgramme(programData)
                      .then((resp) => {
                       const programId = resp.data.id;
                       const studentData = {
                         registration_number:
                           data?.message?.student?.registration_number,
                         full_name: data?.message?.student?.full_name,
                         address: data?.message?.student?.address,
                         phone_number: data?.message?.student?.phone_number,
                         email: data?.message?.student?.email,
                         qualification_level:
                           data?.message?.student?.qualification_level,
                         school: schoolId,
                         department: departmentId,
                         programme: programId,
                         is_active: true,
                         recorded_by: user.id,
                       };
                       appCRUD
                         .addStudent(studentData)
                         .then((resp) => {
                           const studentId = resp.data.id;
                           const studyData = {
                             student: studentId,
                             study_year: data?.message?.study?.study_year,
                             academic_year: academicId,
                             is_active: true,
                             recorded_by: user.id,
                           };
                           appCRUD
                             .addStudy(studyData)
                             .then(() => {
                               toaster.push(
                                 <Message
                                   type="success"
                                   showIcon
                                   header={"Success"}
                                   closable
                                 >
                                   <p className="h6">
                                     <p className="fw-bold fs-14">
                                       Student Added Successfully
                                     </p>
                                   </p>
                                 </Message>,
                                 { placement: "topEnd", duration: 7000 }
                               );
                               setLoading(false);
                               setOpen(false);
                               setIndex(index + 1);
                             })
                             .catch((error) => {
                               toaster.push(
                                 <Message
                                   type="error"
                                   showIcon
                                   header={"Error"}
                                   closable
                                 >
                                   <p className="h6">
                                     <p className="fw-bold fs-14">
                                       Oooh Sorry...!
                                     </p>
                                     <p className="text-dark fs-12">{error}.</p>
                                   </p>
                                 </Message>,
                                 { placement: "topEnd", duration: 7000 }
                               );
                               setLoading(false);
                             });
                         })
                         .catch((error) => {
                           toaster.push(
                             <Message
                               type="error"
                               showIcon
                               header={"Error"}
                               closable
                             >
                               <p className="h6">
                                 <p className="fw-bold fs-14">Oooh Sorry...!</p>
                                 <p className="text-dark fs-12">{error}.</p>
                               </p>
                             </Message>,
                             { placement: "topEnd", duration: 7000 }
                           );
                           setLoading(false);
                         });
                      })
                      .catch((error) => {
                        toaster.push(
                          <Message
                            type="error"
                            showIcon
                            header={"Error"}
                            closable
                          >
                            <p className="h6">
                              <p className="fw-bold fs-14">Oooh Sorry...!</p>
                              <p className="text-dark fs-12">{error}.</p>
                            </p>
                          </Message>,
                          { placement: "topEnd", duration: 7000 }
                        );
                        setLoading(false);
                      });
                  })
                  .catch((error) => {
                    toaster.push(
                      <Message
                        type="error"
                        showIcon
                        header={"Error"}
                        closable
                      >
                        <p className="h6">
                          <p className="fw-bold fs-14">Oooh Sorry...!</p>
                          <p className="text-dark fs-12">{error}.</p>
                        </p>
                      </Message>,
                      { placement: "topEnd", duration: 7000 }
                    );
                    setLoading(false);
                  });
            }).catch((error) => {
                toaster.push(
                  <Message
                    type="error"
                    showIcon
                    header={"Error"}
                    closable
                  >
                    <p className="h6">
                      <p className="fw-bold fs-14">Oooh Sorry...!</p>
                      <p className="text-dark fs-12">{error}.</p>
                    </p>
                  </Message>,
                  { placement: "topEnd", duration: 7000 }
                );
                setLoading(false);
            });
        }else if(schoolId && !departmentId && !programId){
            const departmentData = {
                name : data?.message?.department?.name,
                code : data?.message?.department?.code,
                school : schoolId,
                is_active : true,
                recorded_by : user.id
            }
            appCRUD.addDepartment(departmentData).then((resp) => {
                 const departmentId = resp.data.id;
                 const programData = {
                   name: data?.message?.programme?.name,
                   code: data?.message?.programme?.code,
                   department: departmentId,
                   is_active: true,
                   recorded_by: user.id,
                 };
                 appCRUD
                   .addProgramme(programData)
                   .then((resp) => {
                     const programId = resp.data.id;
                     const studentData = {
                       registration_number:
                         data?.message?.student?.registration_number,
                       full_name: data?.message?.student?.full_name,
                       address: data?.message?.student?.address,
                       phone_number: data?.message?.student?.phone_number,
                       email: data?.message?.student?.email,
                       qualification_level:
                         data?.message?.student?.qualification_level,
                       school: schoolId,
                       department: departmentId,
                       programme: programId,
                       is_active: true,
                       recorded_by: user.id,
                     };
                     appCRUD
                       .addStudent(studentData)
                       .then((resp) => {
                         const studentId = resp.data.id;
                         const studyData = {
                           student: studentId,
                           study_year: data?.message?.study?.study_year,
                           academic_year: academicId,
                           is_active: true,
                           recorded_by: user.id,
                         };
                         appCRUD
                           .addStudy(studyData)
                           .then(() => {
                             toaster.push(
                               <Message
                                 type="success"
                                 showIcon
                                 header={"Success"}
                                 closable
                               >
                                 <p className="h6">
                                   <p className="fw-bold fs-14">
                                     Student Added Successfully
                                   </p>
                                 </p>
                               </Message>,
                               { placement: "topEnd", duration: 7000 }
                             );
                             setLoading(false);
                             setOpen(false);
                             setIndex(index + 1);
                           })
                           .catch((error) => {
                             toaster.push(
                               <Message
                                 type="error"
                                 showIcon
                                 header={"Error"}
                                 closable
                               >
                                 <p className="h6">
                                   <p className="fw-bold fs-14">
                                     Oooh Sorry...!
                                   </p>
                                   <p className="text-dark fs-12">{error}.</p>
                                 </p>
                               </Message>,
                               { placement: "topEnd", duration: 7000 }
                             );
                             setLoading(false);
                           });
                       })
                       .catch((error) => {
                         toaster.push(
                           <Message
                             type="error"
                             showIcon
                             header={"Error"}
                             closable
                           >
                             <p className="h6">
                               <p className="fw-bold fs-14">Oooh Sorry...!</p>
                               <p className="text-dark fs-12">{error}.</p>
                             </p>
                           </Message>,
                           { placement: "topEnd", duration: 7000 }
                         );
                       });
                       setLoading(false);
                   })
                   .catch((error) => {
                     toaster.push(
                       <Message type="error" showIcon header={"Error"} closable>
                         <p className="h6">
                           <p className="fw-bold fs-14">Oooh Sorry...!</p>
                           <p className="text-dark fs-12">{error}.</p>
                         </p>
                       </Message>,
                       { placement: "topEnd", duration: 7000 }
                     );
                     setLoading(false);
                   });
            }).catch((error) => {
                toaster.push(
                  <Message type="error" showIcon header={"Error"} closable>
                    <p className="h6">
                      <p className="fw-bold fs-14">Oooh Sorry...!</p>
                      <p className="text-dark fs-12">{error}.</p>
                    </p>
                  </Message>,
                  { placement: "topEnd", duration: 7000 }
                );
                setLoading(false);
            });
        } else if(schoolId && departmentId && !programId){
            const programData = {
                name : data?.message?.programme?.name,
                code : data?.message?.programme?.code,
                department : departmentId,
                is_active : true,
                recorded_by : user.id
            }
            appCRUD.addProgramme(programData).then((resp) => {
                const programId = resp.data.id;
                const studentData = {
                  registration_number:
                    data?.message?.student?.registration_number,
                  full_name: data?.message?.student?.full_name,
                  address: data?.message?.student?.address,
                  phone_number: data?.message?.student?.phone_number,
                  email: data?.message?.student?.email,
                  qualification_level:
                    data?.message?.student?.qualification_level,
                  school: schoolId,
                  department: departmentId,
                  programme: programId,
                  is_active: true,
                  recorded_by: user.id,
                };
                appCRUD
                  .addStudent(studentData)
                  .then((resp) => {
                    const studentId = resp.data.id;
                    const studyData = {
                      student: studentId,
                      study_year: data?.message?.study?.study_year,
                      academic_year: academicId,
                      is_active: true,
                      recorded_by: user.id,
                    };
                    appCRUD
                      .addStudy(studyData)
                      .then(() => {
                        toaster.push(
                          <Message
                            type="success"
                            showIcon
                            header={"Success"}
                            closable
                          >
                            <p className="h6">
                              <p className="fw-bold fs-14">
                                Student Added Successfully
                              </p>
                            </p>
                          </Message>,
                          { placement: "topEnd", duration: 7000 }
                        );
                        setLoading(false);
                        setOpen(false);
                        setIndex(index + 1);
                      })
                      .catch((error) => {
                        toaster.push(
                          <Message
                            type="error"
                            showIcon
                            header={"Error"}
                            closable
                          >
                            <p className="h6">
                              <p className="fw-bold fs-14">Oooh Sorry...!</p>
                              <p className="text-dark fs-12">{error}.</p>
                            </p>
                          </Message>,
                          { placement: "topEnd", duration: 7000 }
                        );
                        setLoading(false);
                      });
                  })
                  .catch((error) => {
                    toaster.push(
                      <Message type="error" showIcon header={"Error"} closable>
                        <p className="h6">
                          <p className="fw-bold fs-14">Oooh Sorry...!</p>
                          <p className="text-dark fs-12">{error}.</p>
                        </p>
                      </Message>,
                      { placement: "topEnd", duration: 7000 }
                    );
                    setLoading(false);
                  });
            }).catch((error) => {
                toaster.push(
                  <Message type="error" showIcon header={"Error"} closable>
                    <p className="h6">
                      <p className="fw-bold fs-14">Oooh Sorry...!</p>
                      <p className="text-dark fs-12">{error}.</p>
                    </p>
                  </Message>,
                  { placement: "topEnd", duration: 7000 }
                );
                setLoading(false);
            });

        } else if(schoolId && departmentId && programId){ 
            const studentData = {
                registration_number : data?.message?.student?.registration_number,
                full_name : data?.message?.student?.full_name,
                address : data?.message?.student?.address,
                phone_number : data?.message?.student?.phone_number,
                email : data?.message?.student?.email,
                qualification_level : data?.message?.student?.qualification_level,
                school : schoolId,
                department : departmentId,
                programme : programId,
                is_active : true,
                recorded_by : user.id
            }
            appCRUD.addStudent(studentData).then((resp) => {
                const studentId = resp.data.id;
                const studyData = {
                  student: studentId,
                  study_year: data?.message?.study?.study_year,
                  academic_year: academicId,
                  is_active: true,
                  recorded_by: user.id,
                };
                appCRUD.addStudy(studyData).then(() => {
                  toaster.push(
                    <Message type="success" showIcon header={"Success"} closable>
                      <p className="h6">
                        <p className="fw-bold fs-14">Student Added Successfully</p>
                      </p>
                    </Message>,
                    { placement: "topEnd", duration: 7000 }
                  );
                  setLoading(false);
                  setOpen(false);
                  setIndex(index + 1);
                }).catch((error) => {
                    toaster.push(
                      <Message type="error" showIcon header={"Error"} closable>
                        <p className="h6">
                          <p className="fw-bold fs-14">Oooh Sorry...!</p>
                          <p className="text-dark fs-12">{error}.</p>
                        </p>
                      </Message>,
                      { placement: "topEnd", duration: 7000 }
                    );
                    setLoading(false);
                });
            }).catch((error) => {
                toaster.push(
                  <Message type="error" showIcon header={"Error"} closable>
                    <p className="h6">
                      <p className="fw-bold fs-14">Oooh Sorry...!</p>
                      <p className="text-dark fs-12">{error}.</p>
                    </p>
                  </Message>,
                  { placement: "topEnd", duration: 7000 }
                );
                setLoading(false);
            })

        }
    }, 500);
  }

  

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setData([]);
          setIsFound(false);
          setIsStudent(false);
          setIsStudentFound(false);
        }}
        size="md"
      >
        <Modal.Header>
          <Modal.Title>New Student</Modal.Title>
        </Modal.Header>
        <Divider />
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-sm-6">
                <InputGroup inside>
                  <Input
                    onChange={(e) => setSearch(e)}
                    placeholder={"Search by registration number"}
                  />
                  <InputGroup.Button
                    loading={loading}
                    disabled={!search}
                    onClick={handleSearch}
                  >
                    <SearchIcon />
                  </InputGroup.Button>
                </InputGroup>
              </div>
              <div className="col-sm-7 mt-2">
                {isStudentFound ? (
                  <span className="text-bold text-success h6 fs-12">
                    This Student is already registered
                  </span>
                ) : (
                  <span className="text-bold text-danger h6 fs-12">
                    {!isFound && char.toTitleCase(data?.message)}
                  </span>
                )}
              </div>
            </div>
            {isStudent && (
              <>
                <Divider />
                <div className="row">
                  <div className="col-md-3">
                    <p className="h6 fs-13 fw-bold">Registration Number</p>
                  </div>
                  <div className="col-md-1">
                    <p className="h6 fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-7">
                    <p className="h6 fs-14">
                      {data?.message?.student?.registration_number}
                    </p>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <p className="h6 fs-13 fw-bold">Full Name</p>
                  </div>
                  <div className="col-md-1">
                    <p className="h6 fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-7">
                    <p className="h6 fs-14">
                      {char.toTitleCase(data?.message?.student?.full_name)}
                    </p>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <p className="h6 fs-13 fw-bold">Address</p>
                  </div>
                  <div className="col-md-1">
                    <p className="h6 fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-7">
                    <p className="h6 fs-14">
                      {char.toTitleCase(data?.message?.student?.address)}
                    </p>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <p className="h6 fs-13 fw-bold">Phone Number</p>
                  </div>
                  <div className="col-md-1">
                    <p className="h6 fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-7">
                    <p className="h6 fs-14">
                      {data?.message?.student?.phone_number}
                    </p>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <p className="h6 fs-13 fw-bold">Email</p>
                  </div>
                  <div className="col-md-1">
                    <p className="h6 fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-7">
                    <p className="h6 fs-14">{data?.message?.student?.email}</p>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <p className="h6 fs-13 fw-bold">Study Level</p>
                  </div>
                  <div className="col-md-1">
                    <p className="h6 fs-14 fw-bold">:</p>
                  </div>
                  <div className="col-md-7">
                    <p className="h6 fs-14">
                      {char.toTitleCase(
                        data?.message?.student?.qualification_level
                      )}
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
        <Divider style={{ marginTop: -10 }} />
        <Modal.Footer>
          {!isStudentFound && data && data?.code === 200 ? (
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 d-flex justify-content-start"></div>
                <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button
                    onClick={() => {
                      setOpen(false);
                      setData([]);
                      setIsFound(false);
                      setIsStudent(false);
                      setIsStudentFound(false);
                    }}
                    type="button"
                    className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                  >
                    <i class="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                    disabled={loading}
                    onClick={handleSubmit}
                  >
                    {!loading && (
                      <span className="indicator-label">
                        <i class="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                        Save
                      </span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 d-flex justify-content-start"></div>
                <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button
                    onClick={() => {
                      setOpen(false);
                      setData([]);
                      setIsFound(false);
                      setIsStudent(false);
                      setIsStudentFound(false);
                    }}
                    type="button"
                    className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                  >
                    <i class="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
